import SessionStorage from '../../api/session-storage';
import { createDispatchFunction } from '../../api/stateHelper';
import Requests from '../../api/requests';
import { partial } from 'lodash';
import * as types from '../../api/types';

export function receivedLogout(hasUserLoggedOut) {
  return {
    type: types.RECEIVED_LOGOUT,
    hasUserLoggedOut,
  };
}

export function receivedAdmin(admin) {
  return {
    type: types.RECEIVED_ADMIN,
    admin,
  };
}

export function receivedLogUserIn(isLogged) {
  return {
    type: types.RECEIVED_LOG_USER_IN,
    isLogged,
  };
}

export function receivedUserInfo(userInfo) {
  return {
    type: types.RECEIVED_USER_INFO,
    userInfo,
  };
}

export function receivedRoom(room) {
  return {
    type: types.RECEIVED_ROOM,
    room,
  };
}

export function updateCofirmationIndAction(payload) {
  return {
    type: types.UPDATE_CONFIRMATION_IND,
    payload,
  };
}

export function saveRoom(room) {
  return function (dispatch) {
    SessionStorage.saveRoom(room);
    dispatch(receivedRoom(room));
  };
}

export function saveLoggedOutUser(hasUserLoggedOut) {
  return function (dispatch) {
    SessionStorage.saveUserLoggedOut(hasUserLoggedOut);
    dispatch(receivedLogout(hasUserLoggedOut));
  };
}

export function saveAdmin(admin) {
  return function (dispatch) {
    SessionStorage.saveAdmin(admin);
    dispatch(receivedAdmin(admin));
  };
}

export function saveUser(user) {
  return function (dispatch) {
    SessionStorage.saveUser(user);
    dispatch(receivedUserInfo(user));
  };
}

export function saveLoggedUser(isLogged) {
  return function (dispatch) {
    SessionStorage.saveLoggedUser(isLogged);
    dispatch(receivedLogUserIn(isLogged));
  };
}

export function updateCofirmationInd(user) {
  return createDispatchFunction(
    partial(Requests.updateCofirmationInd, user),
    updateCofirmationIndAction,
  );
}
